import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { MissionControlContext } from "./context";
import HttpMissionControlAPI from "./http";
export default function MissionControlProvider({ auth, children, }) {
    const api = useMemo(() => new HttpMissionControlAPI(auth), [auth]);
    return (_jsx(MissionControlContext.Provider, { value: api, children: children }));
}
